import { useMemo } from 'react';
import { isFulfillmentLastItemPosition } from '../utils/fulfillment';

export const useFulfillmentPosition = components => {
  const { available_quantity, fulfillment_information, stock_information } = components || {};
  const availableQuantityState = available_quantity?.state;
  const fulfillmentInformationState = fulfillment_information?.state;
  const stockInformationState = stock_information?.state;

  return useMemo(
    () => isFulfillmentLastItemPosition(availableQuantityState, fulfillmentInformationState, stockInformationState),
    [availableQuantityState, fulfillmentInformationState, stockInformationState],
  );
};
